import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import sortBy from 'lodash/sortBy';

import { fetchAffiliateFAQs } from '../store/reducer/affiliateFAQsSlice';

export const useAffiliateFAQs = () => {
  const dispatch = useDispatch();
  const { data, loading } = useSelector((state) => state?.affiliateFaqs);

  const [affiliateFAQList, setAffiliateFaqList] = useState([]);

  useEffect(() => {
    if (!loading && !Object.keys(data)?.length) {
      dispatch(fetchAffiliateFAQs());
    }
  }, []);

  useEffect(() => {
    setAffiliateFaqList([...(sortBy(data?.data?.faqList, 'priorityIndex') ?? [])]);
  }, [data?.data?.faqList]);

  return {
    loading,
    affiliateFAQList,
  };
};
